import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { faAngleDown, faAngleUp } from '@fortawesome/pro-light-svg-icons'
import { faCommentSlash } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Collapse } from 'antd'
import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'
import { api as http } from '~/api/services'
import Loading from '../Loading'
import NoData from '../NoData'
import './MeetingQuestionAnswer.less'

const { Panel } = Collapse

const MeetingQuestionAnswer = ({ meetingId, acceptingRequest = false }) => {
  const [answers, setAnswers] = useState(null)
  const [loading, setLoading] = useState(false)
  const [hasAnswers, setHasAnswers] = useState(false)

  useEffect(() => {
    setLoading(true)
    http
      .get(`/meeting/questions/answers/${meetingId}`)
      .then((response) => {
        setAnswers(response.data.result)
        if (!isEmpty(response.data.result)) {
          const res = response.data.result.filter((x) => x.answer !== '')
          setHasAnswers(res.length > 0)
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }, [meetingId])

  return (
    <div className="MeetingAnswers-Container">
      {(isEmpty(answers) || !hasAnswers) && !loading ? (
        acceptingRequest ? (
          <p />
        ) : (
          <div>
            <NoData
              title="No answers"
              icon={<FontAwesomeIcon icon={faCommentSlash} size="2x" />}
            />
          </div>
        )
      ) : (
        <Loading spinning={loading}>
          {hasAnswers && (
            <div>
              <div
                style={{ marginBottom: '16px' }}
                className="online-meeting-date-time-text"
              >
                Answers
              </div>
              {map(
                answers,
                (a) =>
                  a.answer !== '' && (
                    <Collapse
                      bordered={false}
                      expandIconPosition="right"
                      className="MeetingAnswers-CollapseHeader"
                      key={a.question}
                      expandIcon={({ isActive }) => (
                        <FontAwesomeIcon
                          icon={isActive ? faAngleUp : faAngleDown}
                          className="MeetingAnswers-ExpandIcon"
                        />
                      )}
                    >
                      <Panel
                        key={a.question}
                        header={a.question}
                        className="MeetingAnswers-QuestionHeader"
                      >
                        <div className="MeetingAnswers-AnswerBody">
                          {a.answer}
                        </div>
                      </Panel>
                    </Collapse>
                  )
              )}
            </div>
          )}
        </Loading>
      )}
    </div>
  )
}

MeetingQuestionAnswer.propTypes = {
  meetingId: PropTypes.number.isRequired,
  acceptingRequest: PropTypes.bool,
}

export default MeetingQuestionAnswer
